import { ConfigProvider, Divider, message, Modal, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import { convertBase64ToBlob } from "../../utils/Common";
import CustomInput from "../CustomInput";

function AddGroupModal({ openModal, records }) {
  const [group, setGroup] = useState("");
  const [croppedFile, setCroppedFile] = useState(null);
  const { user, restaurantSlug } = useUserStore();
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);

  useEffect(() => {
    if (openModal) {
      fetchRestaurants();
    }
  }, [openModal]);

  const fetchRestaurants = async () => {
    const params = {
      restaurantSlug,
      page: 1,
      perPage: 9999999
    };
    
    try {
      const response = await ApiService.GET_RESTAURANT(
        params,
        user.token.token
      );
      if (response?.payload?.records) {
        setRestaurants(response.payload.records);
      }
    } catch (error) {
      console.error("Error fetching restaurants:", error);
      message.error("Failed to load restaurants");
    }
  };

  const options = restaurants.map((restaurant) => ({
    value: restaurant.restaurantId,
    label: restaurant.restaurantFullName,
  }));

  const handleChange = (values) => {
    const selected = values
      .map((value) => {
        const restaurant = options.find((option) => option.value === value);
        return restaurant
          ? { value: restaurant.value, label: restaurant.label }
          : null;
      })
      .filter(Boolean); // Remove any null values
    setSelectedRestaurants(selected);
  };

  const handleOk = () => {
    const imageFile = croppedFile ? convertBase64ToBlob(croppedFile) : null;
    records.onFinish({
      showModal: false,
      param: { group, imageFile, selectedRestaurants },
    });
    resetState();
  };

  const handleCancel = () => {
    records.onCancel();
    resetState();
  };

  const resetState = () => {
    setGroup("");
    setSelectedRestaurants([]);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">Add Group</div>
          <Divider />
          <CustomInput
            value={group}
            setValue={setGroup}
            showPadding={false}
            label="Group Name"
            required
            onPressEnter={handleOk}
            placeholder="e.g. KFC or Pizza Hut"
          />
          <div className="flex flex-col">
            <div className="flex flex-row mb-[16px] font-uregular rounded bg-white items-center">
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                <div className="ml-[4px] text-sm font-uregular flex flex-row">
                  <div>Select Restaurants</div>
                </div>
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please Select Restaurants"
                  onChange={handleChange}
                  options={options}
                  value={selectedRestaurants.map((item) => item.value)} // Controlled component
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  getPopupContainer={(triggerNode) => triggerNode.parentNode} // Ensures dropdown is within modal
                />
              </Space>
            </div>
          </div>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default AddGroupModal;
